import { useCallback, useEffect, useRef, useState } from 'react';

type FeedMode = 'live' | 'game';

/** Let the thumb move before replacing the empty screen; no page transition. */
export function useFeedSwitch(initial: FeedMode, inArena: boolean) {
  const [feed, setFeed] = useState(initial);
  const [selectedFeed, setSelectedFeed] = useState(initial);
  const current = useRef(initial);
  const requested = useRef(initial);
  const timer = useRef<number | undefined>(undefined);
  const commit = useCallback((next: FeedMode) => {
    current.current = next;
    setFeed(next);
  }, []);
  const changeFeed = useCallback(
    (next: FeedMode) => {
      window.clearTimeout(timer.current);
      requested.current = next;
      setSelectedFeed(next);
      if (
        next === current.current ||
        !inArena ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        commit(next);
      } else {
        timer.current = window.setTimeout(() => commit(next), 180);
      }
    },
    [commit, inArena],
  );
  useEffect(() => {
    if (!inArena) {
      window.clearTimeout(timer.current);
      commit(requested.current);
    }
  }, [commit, inArena]);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  return { feed, selectedFeed, changeFeed };
}
